import type { Nullable } from "@eroad/types";
/**
 * Type guard for checking if a value is defined.
 * Use `isNil` helper if you want to check if a value is null or undefined.
 */
function isDefined<T>(x: Nullable<T>): x is T {
  return x !== undefined && x !== null;
}

export { isDefined };
